(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gt-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wraps = document.querySelectorAll('[data-carousel]');

    const setup = (wrap) => {
      const scroller = wrap.querySelector('[data-scroller]');
      const prev = wrap.querySelector('[data-scroll-prev]');
      const next = wrap.querySelector('[data-scroll-next]');
      if (!scroller) return;

      const fits = () => scroller.scrollWidth <= scroller.clientWidth + 2;

      const refresh = () => {
        const fitNow = fits();
        wrap.toggleAttribute('data-fits', fitNow);
        if (prev) prev.disabled = fitNow || scroller.scrollLeft <= 1;
        if (next) {
          const max = scroller.scrollWidth - scroller.clientWidth - 1;
          next.disabled = fitNow || scroller.scrollLeft >= max;
        }
      };

      refresh();
      addEventListener('resize', refresh);
      addEventListener('load', refresh);
      scroller.addEventListener('scroll', refresh, { passive: true });

      if (prev) prev.addEventListener('click', () => scroller.scrollBy({ left: -scroller.clientWidth, behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => scroller.scrollBy({ left: scroller.clientWidth, behavior: 'smooth' }));
    };

    wraps.forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-size-quiz"] && !Shopify.designMode) return;
  try {
    
  class SizeQuiz extends HTMLElement {
    connectedCallback() {
      this.sizes = this.dataset.sizes.split(',');
      this.chest = this.dataset.chest.split(',');
      this.length = this.dataset.length.split(',');
      this.sleeve = this.dataset.sleeve.split(',');
      this.usual = null;
      this.fit = null;

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('.gt-quiz__opt');
        if (!btn) return;
        e.preventDefault();
        const group = btn.closest('[data-usual], [data-fit]');
        if (group.hasAttribute('data-usual')) this.usual = btn.dataset.value;
        else this.fit = btn.dataset.value;
        group.querySelectorAll('.gt-quiz__opt').forEach((b) =>
          b.setAttribute('aria-pressed', String(b === btn)));
        this.render();
      });
    }

    render() {
      if (!this.usual || !this.fit) return;
      const i = this.sizes.indexOf(this.usual);
      const atTop = i === this.sizes.length - 1;
      const up = this.fit === 'up' && !atTop;
      const j = up ? i + 1 : i;
      const size = this.sizes[j];

      let note;
      if (this.fit === 'up' && atTop) {
        // never imply a size exists that is not stocked
        note = `${size} is the largest size we make. It is already cut boxy and `
             + `cropped, so it will read oversized on most people.`;
      } else if (up) {
        note = `You normally wear ${this.usual}. For a roomier, longer fit we `
             + `suggest sizing up to ${size}.`;
      } else {
        note = `The hoodie runs true to size, so ${size} gives you the boxy, `
             + `cropped proportion it was cut for.`;
      }

      const out = this.querySelector('[data-result]');
      this.querySelector('[data-size]').textContent = size;
      this.querySelector('[data-note]').textContent = note;
      this.querySelector('[data-measure]').innerHTML =
        `<dt>Chest</dt><dd>${this.chest[j]}"</dd>` +
        `<dt>Body length</dt><dd>${this.length[j]}"</dd>` +
        `<dt>Sleeve</dt><dd>${this.sleeve[j]}"</dd>`;
      out.hidden = false;
    }
  }
  if (!customElements.get('size-quiz')) customElements.define('size-quiz', SizeQuiz);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-worn-worldwide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const setup = (wrap) => {
      const scroller = wrap.querySelector('.gt-ww__scroller');
      const rail = wrap.querySelector('.gt-ww__rail');
      if (!scroller || !rail) return;
      const prevBtn = wrap.querySelector('.gt-ww__arrow--prev');
      const nextBtn = wrap.querySelector('.gt-ww__arrow--next');

      const fits = () => scroller.scrollWidth <= scroller.clientWidth + 2;

      const step = () => {
        const item = rail.querySelector('.gt-ww__item');
        const gap = parseFloat(getComputedStyle(rail).columnGap || '0') || 0;
        return item ? item.getBoundingClientRect().width + gap : scroller.clientWidth * 0.8;
      };

      const updateState = () => {
        const fitNow = fits();
        wrap.toggleAttribute('data-fits', fitNow);
        if (prevBtn) prevBtn.disabled = fitNow || scroller.scrollLeft <= 1;
        if (nextBtn) {
          const max = scroller.scrollWidth - scroller.clientWidth - 1;
          nextBtn.disabled = fitNow || scroller.scrollLeft >= max;
        }
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          scroller.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          scroller.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      // Plain mouse wheels only report vertical delta — redirect it here so
      // desktop users without a trackpad can still scroll the rail.
      scroller.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          scroller.scrollLeft += e.deltaY;
          e.preventDefault();
        }
      }, { passive: false });

      // Click-and-drag for desktop mouse users; suppresses the resulting
      // click on the <a> so a drag never fires as an accidental navigation.
      let dragging = false;
      let dragged = false;
      let startX = 0;
      let startScroll = 0;

      scroller.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return;
        dragging = true;
        dragged = false;
        startX = e.clientX;
        startScroll = scroller.scrollLeft;
        scroller.setPointerCapture(e.pointerId);
      });
      scroller.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 3) dragged = true;
        scroller.scrollLeft = startScroll - dx;
      });
      const endDrag = () => { dragging = false; };
      scroller.addEventListener('pointerup', endDrag);
      scroller.addEventListener('pointercancel', endDrag);
      scroller.addEventListener('click', (e) => {
        if (dragged) {
          e.preventDefault();
          dragged = false;
        }
      }, true);

      scroller.addEventListener('scroll', updateState, { passive: true });
      addEventListener('resize', updateState);
      updateState();
    };

    const init = () => document.querySelectorAll('.gt-ww__nav-wrap').forEach(setup);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // px/second = "scroll speed" setting x 8, so the default 5 reads as a calm 40px/s
    const RATE = 8;

    const build = (root) => {
      if (root.dataset.gtMarqueeReady) return;
      const track = root.querySelector('[data-gt-marquee-track]');
      if (!track) return;
      const originals = Array.from(track.children);
      if (!originals.length) return;
      root.dataset.gtMarqueeReady = '1';

      // every original is readable; only the clones are hidden from AT
      originals.forEach((n) => n.setAttribute('aria-hidden', 'false'));

      const oneSet = () => originals.reduce((s, n) => s + n.getBoundingClientRect().width, 0);

      let one = oneSet();
      if (!one) return;

      // repeat the set until the row is at least twice the visible width, so the
      // loop point is always off-screen
      const target = Math.max(root.clientWidth * 2, one * 2);
      let guard = 0;
      while (track.scrollWidth < target && guard++ < 20) {
        originals.forEach((n) => {
          const c = n.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('ref');
          c.removeAttribute('id');
          track.appendChild(c);
        });
      }

      const apply = () => {
        const w = oneSet();
        if (!w) return;
        const rate = (Number(root.dataset.gtMarqueeSpeed) || 5) * RATE;
        track.style.setProperty('--gt-marquee-distance', w + 'px');
        track.style.setProperty('--gt-marquee-duration', (w / rate).toFixed(2) + 's');
      };
      apply();

      let t;
      addEventListener('resize', () => { clearTimeout(t); t = setTimeout(apply, 150); }, { passive: true });
    };

    const boot = () => document.querySelectorAll('[data-gt-marquee]').forEach(build);
    boot();
    // the theme editor re-renders the section without a full page load
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
